
export default {
    props: {
        value: {
            type: null,
            default: null,
        },

        labels: {
            type: Array,
            default: () => {
                return ['Yes', 'No']
            },
        },

        disabled: Boolean,
    },

    data() {
        return {
            internalValue: null,
        }
    },

    watch: {
        value: {
            handler() {
                this.internalValue = this.value
            },
            immediate: true,
        },
    },

    methods: {
        inputHandler(val) {
            if (this.disabled) return
            this.internalValue = val
            this.$emit('input', this.internalValue)
        },
    },
}
